// src/components/Popup.js

import React, { useEffect, useState, useRef } from 'react';
import '../styles/popup.css';

const Popup = ({ message, onClose, duration = 3000, type = 'top', onVisibilityChange }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isFading, setIsFading] = useState(false);
    const popupRef = useRef(null);
    const onCloseRef = useRef(onClose);
    const onVisibilityChangeRef = useRef(onVisibilityChange);

    // Keep latest onClose without retriggering effects
    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    // Keep latest onVisibilityChange without retriggering effects
    useEffect(() => {
        onVisibilityChangeRef.current = onVisibilityChange;
    }, [onVisibilityChange]);

    // Notify visibility once on mount/unmount only to avoid update loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (typeof onVisibilityChangeRef.current === 'function') {
            onVisibilityChangeRef.current(true);
        }

        // Remove automatic focus
        // if (popupRef.current) {
        //     popupRef.current.focus();
        // }

        // Handle 'Escape' key to close the popup
    const handleEsc = (event) => {
            if (event.key === 'Escape') {
                setIsFading(true);
                setTimeout(() => {
                    setIsVisible(false);
            onCloseRef.current && onCloseRef.current();
                }, 900); // Match the fadeOut animation duration
            }
        };

    window.addEventListener('keydown', handleEsc);

        // Automatically hide the popup after the specified duration
    const timer = setTimeout(() => {
            setIsFading(true);
            setTimeout(() => {
                setIsVisible(false);
        onCloseRef.current && onCloseRef.current();
            }, 900); // Match the fadeOut animation duration
        }, duration);

        // Cleanup event listeners and timers on component unmount
        return () => {
            if (typeof onVisibilityChangeRef.current === 'function') {
                onVisibilityChangeRef.current(false);
            }
            clearTimeout(timer);
            window.removeEventListener('keydown', handleEsc);
        };
    // Intentionally exclude onClose and onVisibilityChange to avoid infinite loops
    }, [duration]);

    // Do not render anything if the popup is not visible
    if (!isVisible) return null;

    // Determine the popup's CSS classes based on its state
    const popupClass = `popup ${isFading ? 'fade-out' : ''}`;

    return (
        <div className={`popup-flex-container popup-${type}`}>
            <div
                className={popupClass}
                role="status"
                aria-live="polite"
                tabIndex="-1"
                ref={popupRef}
            >
                <div className="popup-content">{message}</div>
            </div>
        </div>
    );
};

export default Popup;
